<template>
    <div class="l-wrap-user">
        <div class="l-constrained l-constrained-narrow l-content">
            <div class="container-fluid">

                <div class="row">
                    <div class="col-sm-12">
                        <h1>Merge Campaigns</h1>
                    </div>
                </div>

                <div class="row" v-if="submitError !== ''">
                    <div class="col-sm-12">
                        <div class="alert alert-danger">{{submitError}}</div>
                    </div>
                </div>

                <div class="row" v-if="campaignsCount <= 1">
                    <div class="col-sm-12">
                        <div class="alert alert-warning">There are no campaigns to merge.</div>
                    </div>
                </div>
                <div class="row" v-else v-loading="isBusy">
                    <div class="col-sm-12">
                        <el-form :model="merge" :rules="formRules" ref="mergeForm">
                            <el-form-item label="Merge from (selected month included):" prop="fromDate">
                                <el-date-picker style="width:100%"
                                                v-model="merge.fromDate"
                                                format="yyyy-MM"
                                                value-format="yyyy-MM"
                                                type="month"/>
                            </el-form-item>

                            <el-form-item label="Parent Campaign (Target Campaign)" prop="parentCampaignId">
                                <el-select v-model="merge.parentCampaignId"
                                           style="width:100%">
                                    <el-option v-for="campaign in campaignsFiltered"
                                               :key="`campaign-${campaign.id}`"
                                               :label="`${campaign.name} (${campaign.id})`"
                                               :value="campaign.id"/>
                                </el-select>
                            </el-form-item>

                            <div v-if="merge.parentCampaignId !== ''">
                                <el-form-item label="Campaign to be merged" prop="campaignsToBeMerged">
                                    <el-select v-model="campaignToBeMergeCache"
                                               style="width:100%"
                                               :placeholder="merge.campaignsToBeMerged.length > 0 ? 'Select next campaign' : 'Select campaign'"
                                               @change="addCampaign">
                                        <el-option v-for="campaign in campaignsFiltered"
                                                   :key="`campaign-${campaign.id}`"
                                                   :label="`${campaign.name} (${campaign.id})`"
                                                   :value="campaign.id"/>
                                    </el-select>
                                </el-form-item>

                                <div class="row">
                                    <div class="col-sm-12">
                                        <ul style="list-style-type:none;padding-left:0;">
                                            <li v-for="campaignId in merge.campaignsToBeMerged">
                                                <el-link @click="removeCampaign(campaignId)"><i class="fa fa-close"
                                                                                                style="position:relative;top:-3px;color:red;margin-right:5px;"></i>
                                                </el-link>
                                                {{ campaignsById[campaignId] }} ({{campaignId}})
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <el-button type="primary" @click="submitForm">
                                <i class="fa fa-code-fork" style="padding-right:8px"></i>Merge Campaigns
                            </el-button>
                        </el-form>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            campaigns: { type: Array, required: true },
            employerId: { type: Number, required: true },
        },
        data() {
            return {
                merge: {
                    fromDate: '',
                    newCampaignName: '',
                    parentCampaignId: '',
                    campaignsToBeMerged: [],
                },
                isBusy: false,
                submitError: '',
                campaignToBeMergeCache: '',
                formRules: {
                    fromDate: [
                        {
                            required: true,
                            message: 'Please select From date',
                            trigger: 'blur',
                        },
                    ],
                    parentCampaignId: [
                        {
                            required: true,
                            message: 'Please select parent campaign where to merge',
                            trigger: 'blur',
                        },
                    ],
                    campaignsToBeMerged: [
                        {
                            required: true,
                            message: 'Please select campaign to be merged',
                            trigger: 'blur',
                        },
                    ],
                },
            };
        },
        computed: {
            campaignsCount() {
                return this.campaigns.length;
            },
            campaignsFiltered() {
                const $this = this;
                return this.campaigns.filter((item) => {
                    return !$this.merge.campaignsToBeMerged.includes(item.id)
                        && item.id !== $this.merge.parentCampaignId;
                });
            },
            campaignsById() {
                const result = {};
                this.campaigns.map((item) => {
                    result[item.id] = item.name;
                });
                return result;
            },
        },
        methods: {
            addCampaign() {
                if (this.campaignToBeMergeCache) {
                    Vue.set(
                        this.merge.campaignsToBeMerged,
                        this.merge.campaignsToBeMerged.length,
                        this.campaignToBeMergeCache,
                    );
                    this.campaignToBeMergeCache = '';
                }
            },
            removeCampaign(campaignId) {
                if (this.merge.campaignsToBeMerged.length > 0) {
                    let campaignPos = this.merge.campaignsToBeMerged.indexOf(campaignId);
                    this.merge.campaignsToBeMerged.splice(campaignPos, 1);
                }
            },
            submitForm() {
                const formRef = 'mergeForm';
                this.$refs[formRef].validate((valid) => {
                    if (!valid) {
                        return false;
                    }

                    this.postFormRequest();
                });
            },
            postFormRequest() {
                const $this = this;
                $this.isBusy = true;

                axios.post(url(`/admin/employer/${this.employerId}/merge-campaigns`), this.merge)
                     .then((response) => {
                         if (typeof response.data.success === 'undefined' || !response.data.success) {
                             throw Error(response.data.error);
                         }

                         $this.$message.success('Merged!');
                         window.location.href = url(`admin/employer/${$this.employerId}/budgets`);
                     })
                     .catch(err => $this.submitError = err.message)
                     .finally(() => $this.isBusy = false);
            },
        },
    };
</script>

<style scoped>

</style>